import {LANGUAGE} from '@/common/utils/constants';

export const CRUD_SIDE_MENU = {
	[LANGUAGE.en.short]: {
		toolsAndCertificates: 'Tools & Certifications',
		new: 'New',
		export: 'Export',
		action: 'Action',
		status: 'Status',
		id: 'ID',
		label: 'Label',
		type: 'Type',
		createdBy: 'Created By',
		edit: 'Edit',
		approved: 'Approved',
		forApproval: 'Pending',
		inactive: 'Inactive',
		tool: 'Tool',
		certification: 'Certification',
		cancel: 'Cancel',
		projects: '# projects',
		create: 'Create',
		update: 'Update',
		selectStatus: 'Select status',
		selectType: 'Select type',
		addLabel: 'Add label',
		delete: 'Delete',
		areYouSureYouWantToDelete: "Are you sure you want to delete this tool/certificate?",
		willNoLongerBeAssociatedWithAnyProject: "Have in mind that it will no longer be associated with any project",
		areYouSureYouWantToDeleteTheProject: "Are you sure you want to delete the project?"
	},
	[LANGUAGE.de.short]: {
		toolsAndCertificates: 'Werkzeuge und Zertifizierungen',
		new: 'Neu',
		export: 'Export',
		action: 'Aktion',
		status: 'Status',
		id: 'ID',
		label: 'Etikett',
		type: 'Typ',
		createdBy: 'Erstellt von',
		edit: 'Bearbeiten',
		approved: 'Genehmigt',
		forApproval: 'Zur Genehmigung',
		inactive: 'Inaktiv',
		tool: 'Werkzeug',
		certification: 'Zertifizierung',
		cancel: 'Stornieren',
		projects: '# Projekte',
		create: 'Erstellen',
		update: 'Aktualisieren',
		selectStatus: 'Status auswählen',
		selectType: 'Art auswählen',
		addLabel: 'Etikett hinzufügen',
		delete: 'Löschen',
		areYouSureYouWantToDelete: "Sind Sie sicher, dass Sie dieses Tool/Zertifikat löschen möchten?",
		willNoLongerBeAssociatedWithAnyProject: "Beachten Sie, dass es keinem Projekt mehr zugeordnet wird",
		areYouSureYouWantToDeleteTheProject: "Sind Sie sicher, dass Sie das Projekt löschen möchten?"
	},
	[LANGUAGE.fr.short]: {
		toolsAndCertificates: 'Outils et certifications',
		new: 'Nouveau',
		export: 'Exporter',
		action: 'Action',
		status: 'Statut',
		id: 'ID',
		label: 'Étiquette',
		type: 'Taper',
		createdBy: 'Créé par',
		edit: 'Modifier',
		approved: 'Approuvé',
		forApproval: 'En attente d\'approbation',
		inactive: 'Inactif',
		tool: 'Outil',
		certification: 'Attestation',
		cancel: 'Annuler',
		projects: '# projets',
		create: 'Créer',
		update: 'Mise à jour',
		selectStatus: 'Sélectionnez le statut',
		selectType: 'Sélectionner le genre',
		addLabel: 'Ajouter une étiquette',
		delete: 'Supprimer',
		areYouSureYouWantToDelete: "Voulez-vous vraiment supprimer cet outil/certificat?",
		willNoLongerBeAssociatedWithAnyProject: "N'oubliez pas qu'il ne sera plus associé à aucun projet.",
		areYouSureYouWantToDeleteTheProject: "Voulez-vous vraiment supprimer le projet?"
	},
	[LANGUAGE.it.short]: {
		toolsAndCertificates: 'Strumenti e certificazioni',
		new: 'Nuovo',
		export: 'Esportare',
		action: 'Azione',
		status: 'Stato',
		id: 'ID',
		label: 'Etichetta',
		type: 'Tipo',
		createdBy: 'Creato da',
		edit: 'Modificare',
		approved: 'Approvato',
		forApproval: 'In attesa di approvazione',
		inactive: 'Inattivo',
		tool: 'Attrezzo',
		certification: 'Certificazione',
		cancel: 'Annulla',
		projects: '# progetti',
		create: 'Creare',
		update: 'Aggiornamento',
		selectStatus: 'Seleziona lo stato',
		selectType: 'Seleziona il tipo',
		addLabel: 'Aggiungi etichetta',
		delete: 'Eliminare',
		areYouSureYouWantToDelete: "Sei sicuro di voler eliminare questo strumento/certificato?",
		willNoLongerBeAssociatedWithAnyProject: "Tieni presente che non sarà più associato a nessun progetto",
		areYouSureYouWantToDeleteTheProject: "Sei sicuro di voler eliminare il progetto?"
	},
	[LANGUAGE.ja.short]: {
		toolsAndCertificates: 'ツールと認定',
		new: '新しい',
		export: '輸出',
		action: 'アクション',
		status: '状態',
		id: 'ID',
		label: 'ラベル',
		type: 'タイプ',
		createdBy: 'によって作成された',
		edit: '編集',
		approved: '承認された',
		forApproval: '承認待ち',
		inactive: '非活性',
		tool: '道具',
		certification: '認証',
		cancel: 'キャンセル',
		projects: '# 件のプロジェクト',
		create: '作成する',
		update: 'アップデート',
		selectStatus: 'ステータスの選択',
		selectType: 'タイプを選択してください',
		addLabel: 'ラベルを追加する',
		delete: '消去',
		areYouSureYouWantToDelete: "このツール/証明書を削除してもよろしいですか?",
		willNoLongerBeAssociatedWithAnyProject: "どのプロジェクトにも関連付けられなくなることに注意してください。",
		areYouSureYouWantToDeleteTheProject: "このプロジェクトを削除してもよろしいですか?"
	},
	[LANGUAGE.es.short]: {
		toolsAndCertificates: 'Herramientas y certificaciones',
		new: 'Nuevo',
		export: 'Exportar',
		action: 'Acción',
		status: 'Estado',
		id: 'ID',
		label: 'Etiqueta',
		type: 'Tipo',
		createdBy: 'Creado por',
		edit: 'Editar',
		approved: 'Aprobado',
		forApproval: 'Pendiente de aprobación',
		inactive: 'Inactivo',
		tool: 'Herramienta',
		certification: 'Certificación',
		cancel: 'Cancelar',
		projects: '# proyectos',
		create: 'Crear',
		update: 'Actualizar',
		selectStatus: 'Seleccionar estado',
		selectType: 'Seleccionar tipo',
		addLabel: 'Agregar etiqueta',
		delete: 'Eliminar',
		areYouSureYouWantToDelete: "¿Está seguro de que desea eliminar esta herramienta/certificación?",
		willNoLongerBeAssociatedWithAnyProject: "Tenga en cuenta que ya no estará asociado con ningún proyecto",
		areYouSureYouWantToDeleteTheProject: "¿Está seguro de que desea eliminar el proyecto?"
	}
}
